import React, { useState } from 'react';
import '../masteraccount.css';
import mastercardLogo from '../images/cc-mastercardlogo.png';
import visaLogo from '../images/cc-visalogo.png';

const PaymentMethodPage = () => {
  // Payment methods come from billing APIs — never invent cardholder names.
  const [cards] = useState([]);

  const handleAddCard = () => {
    // This will be handled separately from the modal
    console.log('Add new card');
  };

  const scrollCards = (direction) => {
    const container = document.querySelector('.payment-method-cards');
    const scrollAmount = direction === 'next' ? 264 : -264; // card width + gap
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  return (
    <>
      <div className="profile-header">
        <h2>Payment Method</h2>
      </div>
      
      <div className="payment-method-content">
        <div className="payment-method-cards-container">
          <button className="cards-nav-button prev" onClick={() => scrollCards('prev')} aria-label="Previous cards">
            <svg viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
            </svg>
          </button>
          <div className="payment-method-cards">
            {cards.map((card, index) => (
              <div key={index} className="payment-method-card-wrapper">
                <div className={`payment-method-card ${card.type}`}>
                  <div className="card-header">
                    {card.type === 'mastercard' ? (
                      <img 
                        src={mastercardLogo}
                        alt="Mastercard"
                        className="card-logo mastercard"
                      />
                    ) : (
                      <img 
                        src={visaLogo}
                        alt="Visa"
                        className="card-logo visa"
                      />
                    )}
                    <div className="card-options">•••</div>
                  </div>
                  <div className="card-body">
                    <div className="card-number">•••• •••• •••• {card.number}</div>
                    <div className="card-details">
                      <div className="card-name">
                        <div className="label">NAME</div>
                        <div>{card.name}</div>
                      </div>
                      <div className="card-expiry">
                        <div className="label">EXPIRY DATE</div>
                        <div>{card.expiry}</div>
                      </div>
                    </div>
                  </div>
                </div>
                {card.type === 'mastercard' && (
                  <div className="default-indicator">Default</div>
                )}
              </div>
            ))}
            
            <div className="payment-method-add-card" onClick={handleAddCard}>
              <div className="add-icon">+</div>
              <div>Add Payment Method</div>
            </div>
          </div>
          <button className="cards-nav-button next" onClick={() => scrollCards('next')} aria-label="Next cards">
            <svg viewBox="0 0 24 24">
              <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
            </svg>
          </button>
        </div>

        <div className="payment-method-billing-history">
          <h3>Billing History</h3>
          <p>View invoices for all payments made on your KrossKast account.</p>
          
          <div className="payment-method-billing-table">
            <div className="payment-method-billing-headers">
              <div>#</div>
              <div>Transaction ID</div>
              <div>Description</div>
              <div>Date</div>
              <div>Status</div>
              <div>Amount</div>
            </div>
            
            <div className="payment-method-billing-row">
              <div>1</div>
              <div className="transaction-id">#7634y4902</div>
              <div>KrossKast Player - Hardware Purchase</div>
              <div>01/15/2024 - 01:30:31 PM</div>
              <div><span className="status-badge status-complete">Complete</span></div>
              <div>$299.99</div>
            </div>
            <div className="payment-method-billing-row">
              <div>2</div>
              <div className="transaction-id">#7634y4905</div>
              <div>Annual Music Subscription</div>
              <div>01/15/2024 - 01:40:31 PM</div>
              <div><span className="status-badge status-failed">Failed</span></div>
              <div>$1,200.00</div>
            </div>
            <div className="payment-method-billing-row">
              <div>3</div>
              <div className="transaction-id">#7634y4906</div>
              <div>KrossKast Player - Hardware Purchase</div>
              <div>01/14/2024 - 05:31:01 AM</div>
              <div><span className="status-badge status-hold">On hold</span></div>
              <div>$299.99</div>
            </div>
            <div className="payment-method-billing-row">
              <div>4</div>
              <div className="transaction-id">#7634y4909</div>
              <div>Annual Music Subscription</div>
              <div>01/12/2024 - 01:52:31 AM</div>
              <div><span className="status-badge status-pending">Pending</span></div>
              <div>$1,200.00</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentMethodPage; 